var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.notification)?_c('div',{staticClass:"notification",class:_vm.notification.type},[_c('h4',[_vm._v(_vm._s(_vm.notification.title))]),_c('p',[_vm._v(_vm._s(_vm.notification.message))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }